// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[2]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[3].use[3]!../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[3].use[4]!components/ui/common.module.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._0ef4ce{display:flex;align-items:center;color:var(--secondary);align-items:center}._796292{margin:0 .5em;opacity:.5}.eb0771{max-width:12em}.eb0771._849d7b{max-width:30em}.eb0771:not(:last-child){flex-shrink:0}._343bea{white-space:normal;max-width:none}.eb0771:not(._343bea):last-child{font-size:1.25em;color:var(--black);font-weight:600}", ""]);
// Exports
exports.locals = {
	"breadcrumbs": "_0ef4ce",
	"separator": "_796292",
	"item": "eb0771 " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["no-wrap-ellipsis"] + "",
	"long": "_849d7b",
	"multi-line": "_343bea",
	"multiLine": "_343bea"
};
module.exports = exports;
